import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from 'src/app/services/sharedService';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { EventEmitter } from 'events';
import { DialogData } from 'src/app/entities/dialogData';
import { UserStatusName, replaceValues } from 'src/app/entities/util';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/entities/user';
import { UserStatus } from 'src/app/entities/states/userStatus';
import { DialogCommunicator } from '../dialog-communicator';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { TaxPayer } from 'src/app/entities/taxPayer';

@Component({
  selector: 'gov-tax-payer-dialog',
  templateUrl: './tax-payer-dialog.component.html',
  styleUrls: ['./tax-payer-dialog.component.css']
})
export class TaxPayerDialogComponent extends DialogCommunicator implements OnInit {

  text: string;
  emitter: EventEmitter;
  company: any;
  statusNames = UserStatusName
  userStatus = UserStatus
  branches = [];
  usernames = [];
  
  repeatPassword = "";
  constructor(
    public dialogRef: MatDialogRef<TaxPayerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public sharedService: SharedService, public taxPayerService: TaxPayerService, public confirmationDialog: MatDialog) {
    super(dialogRef, sharedService)
    this.setConfirmationDialog(this.confirmationDialog)
  }

  ngOnInit() {
    this.company = new TaxPayer()
      // this.userService.getUserroles().subscribe(resUserRoles => {
      //   this.userroles = resUserRoles;
      // })
    
      if (this.data) {
        this.taxPayerService.getResource('tax-payers', this.data['id']).subscribe(val => {
          this.company = val
          this.company['class'] = 'TAX-PAYER'
          this.setEntity(this.company);
        }
        )
      } else {
        this.setEntity(this.company);
      }
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (value)
      return option === value;
    return false;
  }

}
